/**
 * El enlace que abre WhatsApp con un mensaje ya escrito · 27-10-2026
 *
 * `https://wa.me/<número>?text=<mensaje>` es la vía pública de WhatsApp para esto,
 * y no cuesta nada: abre la app en el móvil, o WhatsApp Web en el ordenador, con el
 * chat de ese número y el texto puesto. Sin número, WhatsApp deja elegir el contacto.
 *
 * El número lo quiere **solo en cifras y con el prefijo del país**, sin `+` ni
 * espacios. Lo que escribe un club es «612 34 56 78», así que un móvil español de
 * nueve cifras recibe el 34 delante. Uno de fuera necesita el prefijo escrito
 * (`+33…` o `0033…`): sin él no se puede saber de dónde es, y adivinar abriría el
 * chat de otra persona.
 */

/**
 * El número como lo quiere `wa.me`.
 *
 * `''` si no se ha escrito nada —se elegirá el contacto en WhatsApp— y `null` si lo
 * escrito no es un número que se pueda usar.
 */
export function cifrasDelMovil(telefono: string): string | null {
  const limpio = telefono.trim().replace(/[\s().-]/g, '');
  if (limpio === '') return '';

  let cifras: string;
  if (limpio.startsWith('+')) cifras = limpio.slice(1);
  else if (limpio.startsWith('00')) cifras = limpio.slice(2);
  else if (/^[6-9]\d{8}$/.test(limpio)) cifras = `34${limpio}`;
  else if (/^34[6-9]\d{8}$/.test(limpio)) cifras = limpio;
  else return null;

  return /^[1-9]\d{7,14}$/.test(cifras) ? cifras : null;
}

/** El enlace de WhatsApp, o `null` si el número escrito no vale. */
export function enlaceDeWhatsApp(
  mensaje: string,
  telefono: string
): string | null {
  const cifras = cifrasDelMovil(telefono);
  if (cifras === null) return null;
  return `https://wa.me/${cifras}?text=${encodeURIComponent(mensaje)}`;
}
